import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_reduce_margins_for_bf_on_sr",
  stages: {
    main: 1,
    us: 2,
    split_bound: 3
  },
  goals: {},
  defaultStage: 1
});

const trackStages = (splitBound?: boolean, pointOfSale?: string) => {
  utils.stages.main();
  if (pointOfSale === "us") utils.stages.us();
  if (splitBound) utils.stages.split_bound();
};

export default { ...utils, trackStages };
